import { IS_MOBILE } from '@constants/global';

const isAuthPages = () => {
  return ['/login', '/register'].includes(window.location.pathname);
};

export const scrollstop = () => {
  // Virtual keyboard detection and scroll-blocking logic
  let isVirtualKeyboardOpen = false;
  let lastViewportHeight = window.visualViewport
    ? window.visualViewport.height
    : window.innerHeight;

  // Helper: Detect if viewport height shrinks (keyboard open)
  const handleViewportChange = () => {
    const currentHeight = window.visualViewport.height;
    const mobileNavbar = document.querySelector('#mobile-navbar');
    const globalDrawer = document.querySelector('#drawer-global');
    if (lastViewportHeight - currentHeight > 100) {
      if (mobileNavbar) mobileNavbar.classList.add('hidden');
      if (globalDrawer) globalDrawer.style.bottom = '0px';
      isVirtualKeyboardOpen = true;
    } else if (
      isVirtualKeyboardOpen &&
      currentHeight >= lastViewportHeight - 10
    ) {
      window.requestAnimationFrame(() => {
        if (!isAuthPages() && mobileNavbar)
          mobileNavbar.classList.remove('hidden');
        if (globalDrawer) globalDrawer.style.bottom = '60px';
        isVirtualKeyboardOpen = false;
        if (!isAuthPages()) window.scrollTo(0, 0);
      });
    }
    lastViewportHeight = currentHeight;
  };

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', handleViewportChange);
    window.visualViewport.addEventListener(
      'geometrychange',
      handleViewportChange,
    );
  }

  window.addEventListener('scroll', () => {
    if (isVirtualKeyboardOpen || isAuthPages()) return;
    if (window.scrollY !== 0 || window.scrollX !== 0) {
      window.scrollTo(0, 0);
    }
  });
};

export const blockPinchZoom = () => {
  if (!IS_MOBILE()) return;
  // Prevent pinch-zoom and double-tap zoom on iOS
  document.addEventListener(
    'touchstart',
    event => {
      // Check if the user is trying to pinch-to-zoom (more than 1 finger)
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    },
    { passive: false },
  );
};
